import type {
  EmploymentType,
  PayFrequency,
  PurchaseTimeframe,
} from '../types/roadmap'

export const CALENDLY_URL =
  'https://calendly.com/liam-scalefinancestrategies/30min'

export const CONTACT = {
  name: 'Scale Finance Strategies',
  email: 'liam@scalefinancestrategies.com.au',
  phone: '+61 0403 191 672',
  hours: 'Mon – Fri: 8:30 AM – 5:30 PM AWST',
  acn: 'ACN 654344260',
}

export const DISCLAIMER =
  'This roadmap provides general estimates only. It is not a loan approval, formal borrowing-capacity assessment, financial advice or guarantee of eligibility. Income, expenses and liabilities will need to be verified. Actual purchasing costs and lender requirements depend on your circumstances and may change.'

export const BROKER_REASSURANCE =
  'That is a good place to start. Your deposit is only one part of the calculation. Your income, debts, expenses, property price and purchasing costs can all affect how much you may need.'

export const SAVINGS_GOAL_EXPLAINER =
  'Your deposit is not the only amount you may need. It is important to allow for purchasing costs and keep some breathing room after settlement.'

export const INCOME_EXPLAINER =
  'Savings are only one part of the picture. We also need a basic idea of your income to see whether the property goal may be realistic.'

export const COMMITMENTS_NOTE =
  'This gives Liam an initial snapshot only. A proper assessment will require more information and verification.'

export const PRIVACY_NOTE =
  'We never ask for bank logins, passwords, tax file numbers or ID. Nothing you enter here leaves your device unless you choose to get in touch.'

export const TIMEFRAME_OPTIONS: {
  value: PurchaseTimeframe
  label: string
}[] = [
  {
    value: '0-6m',
    label: 'Within 6 months',
  },
  {
    value: '6-12m',
    label: '6 to 12 months',
  },
  {
    value: '1-2y',
    label: '1 to 2 years',
  },
  {
    value: '2y+',
    label: 'More than 2 years away',
  },
]

export const EMPLOYMENT_OPTIONS: {
  value: EmploymentType
  label: string
}[] = [
  {
    value: 'full-time',
    label: 'Full time',
  },
  {
    value: 'part-time',
    label: 'Part time',
  },
  {
    value: 'casual',
    label: 'Casual',
  },
  {
    value: 'self-employed',
    label: 'Self employed',
  },
  {
    value: 'contract',
    label: 'Contract',
  },
  {
    value: 'not-working',
    label: 'Not working right now',
  },
]

export const PAY_FREQUENCY_OPTIONS: {
  value: PayFrequency
  label: string
}[] = [
  {
    value: 'weekly',
    label: 'Weekly',
  },
  {
    value: 'fortnightly',
    label: 'Fortnightly',
  },
  {
    value: 'monthly',
    label: 'Monthly',
  },
]

export const ACTION_CHECKLIST: {
  id: string
  label: string
}[] = [
  {
    id: 'price-range',
    label: 'Confirm my property-price range',
  },
  {
    id: 'deposit-costs',
    label: 'Confirm my deposit and purchasing costs',
  },
  {
    id: 'auto-transfer',
    label: 'Set an automatic savings transfer',
  },
  {
    id: 'separate-account',
    label: 'Keep my property savings separate',
  },
  {
    id: 'cash-buffer',
    label: 'Maintain a cash buffer',
  },
  {
    id: 'avoid-debt',
    label: 'Avoid unnecessary new debts',
  },
  {
    id: 'card-limits',
    label: 'Review unused credit-card limits',
  },
  {
    id: 'review-90',
    label: 'Check my progress again in 90 days',
  },
]

/**
 * The labelled stages shown above the progress bar. Each question screen
 * declares which stage it belongs to, so the bar communicates where the visitor
 * is in the conversation rather than only how far along.
 */
export const STAGES = [
  'Your goal',
  'Property',
  'Savings target',
  'What you have',
  'Income',
  'Your plan',
] as const

export type Stage = (typeof STAGES)[number]
